<template>
  <div class="main">
    <div class="setiont1">
      <div>
        <h2><p style="text-align: left;"><span style="color: #a099cb;">Congratulation!</span></p></h2>
        <p class="congratulation" style="text-align: left;"><i class="el-icon-check"></i> <span>Your have joined our product test program successfully.</span>
        </p>
        <h3>And You Are Selected to <span style="color: #a099cb;">Get One Of Our Exclusive Gift</span></h3>
        <div class="content">
          <div class="content-left">
            <h4><p>About The Free Gift</p></h4>
            <ul style="font-size:13px;line-height:22.1px;">
              <li>
                <div class="fusion-li-item-content">
                  <p><i class="el-icon-rank"></i><strong>Order ID:</strong> {{ amazonOrderId }}</p>
                </div>
              </li>
              <li>
                <div class="fusion-li-item-content">
                  <p>
                    <i class="el-icon-rank"></i>
                    <strong>Product Name:</strong> {{ title }}
                  </p>
                </div>
              </li>
              <li>
                <div class="fusion-li-item-content">
                  <p><i class="el-icon-rank"></i><strong>NO Shipping Charges, NO Hidden Fees, NO Credit Card
                    Required</strong></p>
                </div>
              </li>
              <li>
                <div class="fusion-li-item-content">
                  <p><i class="el-icon-rank"></i><strong>4 Simple Steps to Get It (Generally less than 5
                    minutes)</strong></p>
                </div>
              </li>
              <li>
                <div class="fusion-li-item-content">
                  <p><i class="el-icon-rank"></i>The gift will be shipped in 2-5 working day after we confirm your
                    claiming</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="content-right">
            <ul>
              <li class="zb-gift-item">
                <div class="fusion-img">
                  <header><b>Gift # 1</b></header>
                  <img :src="img_url">
                  <footer>{{ describe }}</footer>
                </div>
                <div class="fusion-button">
                  <!-- 跳转另一个页面 我想要这份礼物（share-experience）-->
                  <el-button
                      @click="$router.push({path:'/share-experience',query:{amazonOrderId:amazonOrderId,image:image,title:title}})">
                    I Want This Gift!
                  </el-button>
                </div>
              </li>
              <li class="fusion-clearfix"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      amazonOrderId: '',
      describe: '',
      img_url: '',
      title: '',
      image: ''
    }
  },
  created() {
    this.amazonOrderId = this.$route.query.amazonOrderId;
    this.describe = this.$route.query.describe;
    this.img_url = this.$route.query.img_url;
    this.image = this.$route.query.image;
    this.title = this.$route.query.title;//接收路由传过来的数据
  },
  activated() {
    // if (!this.$route.meta.isBack) { //true执行
    // // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
    // //清空表单

    // }
    // // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    // this.$route.meta.isBack = false;
  },
  beforeRouteLeave(to, from, next) {
    if (
        to.path == '/gift' ||
        to.path == '/warranty-activated' ||
        to.path == '/share-experience' ||
        to.path == 'share-experience-2' ||
        to.path == 'share-experience-3' ||
        to.path == 'share-experience-4'
    ) {
      //缓存
      from.meta.keepAlive = true;
    } else {
      //不缓存
      from.meta.keepAlive = false;
    }
    next()
  }
}
</script>
<style lang="less" scoped>
.main {
  padding: 0px 30px;

  .setiont1 {
    width: 1170px;
    margin: 0 auto;
    // margin-bottom: 50px;
    // height: 100%;
    h2 {
      margin-top: 30px;
      text-align: left;
      font-size: 32px;
    }

    .congratulation {
      line-height: 40px;
      margin-bottom: 30px;
      font-size: 18px;
      font-weight: bold;

      i {
        font-size: 32px;
        font-weight: bold;
        vertical-align: middle;
        color: #a099cb;
      }
    }

    h3 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 30px;
    }

    .content {
      display: flex;
      justify-content: space-between;
      width: 50%;
      padding-bottom: 50px;
      box-sizing: border-box;

      h4 {
        font-size: 22px;
        text-align: center;
        color: #747474;
        margin-bottom: 20px;
      }

      .content-left,
      .content-right {
        display: flex;
        flex-direction: column;
        // align-items: center;
        //justify-content: start;
        justify-content: flex-start;
        width: 50%;
      }

      .content-left {
        margin-left: 31px;

        li {
          margin-bottom: 10px;
        }

        .fusion-li-item-content {
          i {
            margin-right: 10px;
            font-weight: bold;
            color: #6964c0;
          }
        }
      }

      .content-right {
        flex: 1;
        margin-left: 60px;

        .fusion-img {
          img {
            width: 150px;
          }

          footer {
            line-height: 24px;
          }
        }

        .fusion-button {
          // widows: ;
          height: 60px;
          margin-top: 10px;

          .el-button {
            width: 100%;
            height: 100%;
            // background-color: #887ecc;
            background-color: #a099cb;
            color: #fff;
            font-size: 14px;
          }

          .el-button:hover {
            background-color: #6e5fcc;
          }
        }

      }
    }
  }
}
</style>